import { useEffect, useState } from 'react';

import { Menu } from '@artegeie/design-system/presse'
import { useAuth } from '@artegeie/mrc/context';
import { onLogin, onLogout } from '@artegeie/mona-sdk/auth'

import useRouter from 'Hooks/useRouter';
import useTranslation from 'Hooks/useTranslation';

import 'scss/components/header.scss';

const Header = () => {

	const router = useRouter();
	const { t } = useTranslation();

	const { blogUrl, menu } = window.appConfig;

	const user = useAuth();

	const [ account, setAccount ] = useState( {} );
	const [ accountUrl, setAccountUrl ] = useState( router.buildPath('account_login' ) );

	let account_item = {
		id: "id-account",
		label: t( 'login' ),
		href: accountUrl,
		title: t( 'login' ),
		highlight: true
	};

	useEffect(() => {
		var elementExists = document.getElementById("wpadminbar");
		if( elementExists ) {
			document.body.classList.add('has-admin-bar');
		}
	});

	useEffect(() => {
		var accountExists = document.getElementById("account-menu-item");
		if( accountExists ) {
			accountExists.classList.add('highlight');
		}
	});

	useEffect(() => {
		onLogout((detail) => {

			setAccount( account_item );

		});
		onLogin((detail) => {
			setAccount( {
				id: "id-account",
				label: t('menu.account.myAccount'),
				href: '#',
				title: t('menu.account.myAccount'),
				highlight: true,
				subLinks: menu.account,
			} );
		});
	}, [ user, menu ] );

	const onsubmitSearch = query => {
		if (!query.trim()) {
			return;
		}
		window.location.href = router.buildPath('search', {
			query: query.trim(),
		});
	}

	let search = {
		id: "search-button",
		screenReadersLabel: t( 'search' ),
		placeholder: "...",
		onSubmit: onsubmitSearch,
	}

	let more = {
		id: "id-more",
		label: t('menu.more.label'),
		title: t('menu.more.title'),
	}
	let brand = {
		logo: [ blogUrl, t('menu.brand.logoLabel') ],
		title: "Presse",
		titleHref: blogUrl,
	}

	return (

		<Menu
			style={ null }
			links={ menu.main } // *
			navLabel="menu" // *
			search={ search } // *
			currentLinkId="id-current"
			buttonMore={ more } // *
			brand= { brand }
			account={ account } // *
		/>
	);
};

export default Header;
